import Axios from "../../api/Axios";
const BASE_URL = "TransferofCNandFOC/";

export const EndpointTransferofAdjustedCNandFOC = {
    GetAllTransferCnFoc: "GetAllTransferCnFoc",
    SaveData: "SaveData",
    SaveDebitNote: "SaveDebitNote"

};

export const createAPIEndpointTransferofAdjustedCNandFOC = () => {
    return { 
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint,data)=> Axios.post(BASE_URL+Endpoint,data)
    };
};